export default "__VITE_ASSET__BmSWizCZ__"